const nl = {
  sinObra: "Zonder werf",
  cat: { materiales: "Materiaal", mano_obra: "Arbeid", subcontratas: "Onderaannemers", suministros: "Nutsvoorzieningen", fiscal: "Fiscaal / Belastingen" },
  rama: {
    albanil_oficial: "Metselaar (vakman)", fontanero: "Loodgieter", electricista: "Elektricien", carpinteria_madera: "Schrijnwerk hout",
    carpintero_aluminio: "Aluminium schrijnwerk", gestion_residuos: "Afvalbeheer", transportes: "Transport",
    peones: "Hulparbeiders / Helpers", gestiones_comerciales: "Commerciële taken",
  },
  exento: { si: "Vrijgesteld", marcar: "Als vrijgesteld markeren", marcado: "Uitgave gemarkeerd als vrijgesteld", quitado: "Markering «vrijgesteld» verwijderd", error: "De uitgave kon niet worden bijgewerkt" },
  toast: {
    subida: "Afbeelding geüpload", leyendo: "Afbeelding geüpload · factuurgegevens worden gelezen…", leidos: "Factuurgegevens automatisch gelezen ✨",
    noLeidos: "De gegevens konden niet automatisch worden gelezen. Vul ze handmatig in.", errorSubir: "De afbeelding kon niet worden geüpload",
    registrado: "Uitgave opgeslagen", eliminado: "Uitgave verwijderd",
  },
  jornada: {
    titulo: "Werkuren per werf (limiet {{n}}u/week)", totales: "{{n}}u in totaal",
    excesoObras: "{{n}} werf/werven", excesoTexto: "overschrijden {{n}}u arbeid per week. Bekijk de werklast.",
    vacio: "Nog geen arbeidsuren geregistreerd. Voeg een uitgave toe in de categorie «Arbeid» met de werf en de uren.",
    semExcedidas: "{{n}} week/weken overschreden", resumen: "{{h}}u · {{n}} week/weken", excesoSemana: "{{h}}u boven de wettelijke limiet van {{n}}u.",
  },
  coste: { titulo: "Kosten per werf", ver: "Werven / Projecten bekijken →", obra: "Werf", materiales: "Materiaal", manoObra: "Arbeid", total: "Totale kosten" },
  vacio: { titulo: "Geen uitgaven", hint: "Registreer facturen voor materiaal, arbeid en onderaannemers" },
  tabla: { concepto: "Omschrijving", categoria: "Categorie", fecha: "Datum", horas: "Uren", total: "Totaal", justificante: "bewijsstuk", justificanteM: "Bewijsstuk" },
  form: {
    escanea: "Scan je factuur en wij vullen de gegevens in", quitar: "Afbeelding verwijderen", leyendo: "Lezen…", camara: "Scannen met camera",
    subir: "Bestand uploaden", analizando: "Afbeelding analyseren…",
    ocrBloqueado: "Je kunt de afbeelding bijvoegen; automatisch lezen met AI is beschikbaar vanaf het Kwartaalabonnement.",
    concepto: "Omschrijving", categoria: "Categorie", proveedor: "Leverancier / Bedrijf", base: "Maatstaf (€)", impuesto: "Belasting",
    obra: "Werf / Project", irpf: "IRPF-inhouding (zelfstandigen)", sinRetencion: "Geen inhouding",
    isp: "Verlegging van heffing", ispNota: "(bouwonderaannemer die je factureert zonder btw of IGIC)",
    exento: "Vrijgesteld van belasting", exentoNota: "(verzekeringen, heffingen, woninghuur…)",
    horas: "Uren", rama: "Vakgebied", datosFactura: "Factuurgegevens", numero: "Factuurnr.", hora: "Tijdstip van aankoop",
    nif: "NIF / CIF bedrijf", registro: "Ondernemingsnr.", opcional: "Optioneel", fecha: "Datum",
  },
};

export default nl;
